import styled from '@emotion/styled'

import { BorderRadius } from '../../../../enums/borderRadius'
import { Color } from '../../../../enums/color'
import { Spacing } from '../../../../enums/spacing'
import { getShadow } from '../../../../utils/getShadow'

const FLOATING_PANEL_DEFAULT_BOTTOM = '64px'

interface FloatingPanelWrapperProps {
  isInView: boolean
  bottom?: string
}

export const FloatingPanelWrapper = styled.div<FloatingPanelWrapperProps>`
  padding: ${Spacing.S8} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  position: ${({ isInView }) => (isInView ? 'absolute' : 'fixed')};
  bottom: ${({ bottom }) => bottom ?? FLOATING_PANEL_DEFAULT_BOTTOM};
  background-color: ${Color.White};
  ${getShadow('raisedStrong')}
`
